export class ProductPolicyResponseDto {

	country: string;
	productId: number;
	coverageCategoryId: number;
	productPolicyId: number;
	itemPriceCustomerId: number;   // ← antes “priceBookId” era este
	itemPriceWarrantyId: number;
	itemPriceServiceId: number;
	itemPriceFordCostId: number;
	itemPriceSellerId: number;


	constructor() {
	}
	
}